import tagTester from './_tagTester.js';

export default tagTester('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isWeakSet.js
// module id = 303
// module chunks = 0 1